import { launcherIconSvg } from '../appearance';
import type { LauncherIconKey } from '../types';
import { CHANNEL_BUTTON_COLORS, channelIconSvg } from './channel-icons';
import type { WidgetChannel } from './types';

export type ClosedLauncherPresentation = {
  iconHtml: string;
  background: string | undefined;
  imageUrl: string | null;
};

/** Visible channels already filtered by resolveWidgetChannels. */
export function closedLauncherPresentation(
  channels: WidgetChannel[],
  options: {
    launcherIconKey: LauncherIconKey;
    customIconUrl?: string | null;
  },
): ClosedLauncherPresentation {
  if (channels.length === 1) {
    const channel = channels[0];
    return {
      iconHtml: channelIconSvg(channel.icon || channel.type),
      background: CHANNEL_BUTTON_COLORS[channel.type],
      imageUrl: null,
    };
  }

  const imageUrl = options.customIconUrl?.trim() || null;
  return {
    iconHtml: launcherIconSvg(options.launcherIconKey),
    background: undefined,
    imageUrl,
  };
}
